<template>
  <div>
    <Ibox :back="true" :titulo="'Filtros'">
      <FormGroup
        cols="4"
        label="Empresa"
        :is_loading=filtro.loading_empresa>
        <v-select 
          label="nombre_empresa"
          :clearable=false
          v-model="filtro.id_empresa"
          :reduce="id_empresa=>id_empresa.id_empresa"
          :options=options_empresa>
        </v-select>
      </FormGroup>
      <b-col cols="12">
        <b-button v-if="filtro.loading_empresa" style="float:right" variant="primary"><Loading :size="'1'" :text="'Cargando filtros'"/></b-button>
        <b-button v-else variant="primary" style="float:right" v-on:click="cargarDatos()">Cargar</b-button>
      </b-col>
    </Ibox>
    <Ibox :titulo="'Trabajadores en sucursal '+sucursal.desc_sucursal">
      <b-col cols="12">
        <DataTable
            :loading="loading"
            :columns="columns"
            :rows="rows"
            clases="table-bordered table-hover table-condensed nowrap"
            :buttons="false">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'asociado' && utils.tienePermiso()">
              <a style="color: red" href="javascript:void(0)" v-if="props.row.asociado == 1" v-on:click="putTrabajadorSucursal('N',props.row.id_trabajador)">Quitar</a>
              <a href="javascript:void(0)" v-else-if="props.row.asociado == 0 " v-on:click="putTrabajadorSucursal('S',props.row.id_trabajador)">Agregar</a>
              <span v-else>
                <a href="javascript:void(0)" v-on:click="putTrabajadoresSucursal('S')">Asociar todos</a>
                |
                <a style="color: red" href="javascript:void(0)" v-on:click="putTrabajadoresSucursal('N')">Quitar todos</a>
              </span>
            </span>
              <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </DataTable>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import { userService, sucursalService} from '../../services';
import { utils } from '@/helpers';

export default {
  name: 'UsuarioSucursal',
  data(){
    return {
      filtro: {
        id_empresa:userService.getUser().id_empresa,
        loading_empresa: true,
      },
      options_empresa:[],
      sucursal:utils.jd64(this.$route.params.sucursal),
      utils,
      loading: true,
      columns:[
        {label: 'Empresa', field: 'nombre_empresa'},
        {label: 'Trabajador', field: 'trabajador'},
        {label: '', field: 'asociado'},
      ],
      rows:[],
    }
  },
  mounted () {
    this.cargarEmpresas();
  },
  methods : {
    cargarEmpresas() {
      this.filtro.loading_empresa = true;

      sucursalService.getSucursalEmpresasAsociadas({
        id_cliente:userService.getUser().id_cliente,
        id_sucursal:this.sucursal.id_sucursal
      }).then(respuesta => {
        this.options_empresa = respuesta.data;
        let todo = respuesta.data.map((element) => element.id_empresa).join(',');

        if(userService.getUser().id_empresa == 0){
          if(this.options_empresa.length > 1){
            this.options_empresa.unshift({
              id_empresa:todo,
              nombre_empresa:'Todo'
            });
          }
          this.filtro.id_empresa = todo;
        }
        this.filtro.loading_empresa = false;

        this.cargarDatos();
      });
    },
    cargarDatos(loading = true){
      this.loading = loading;

      sucursalService.getTrabajadoresSucursal({
        id_cliente:userService.getUser().id_cliente,
        id_sucursal:this.sucursal.id_sucursal,
        id_empresa: this.filtro.id_empresa
      }).then(data => {
        this.rows = data.data;

        if(this.rows.length > 0){
          this.rows.unshift({'nombre_empresa':null, 'trabajador':null, 'asociado':'action'});
        }

        this.loading = false;
      });
    },
    putTrabajadorSucursal(estado, id_trabajador){
      sucursalService.putTrabajadorSucursal({
        id_usuario:userService.getUser().id_usuario,
        id_cliente:userService.getUser().id_cliente,
        id_trabajador:id_trabajador,
        estado:estado,
        id_sucursal:this.sucursal.id_sucursal
      }).then(data => {
        if (data.status == "success"){
          this.cargarDatos(false);
        }else{
          utils.alerta(data);
        }
      });
    },
    putTrabajadoresSucursal(estado){
      sucursalService.putTrabajadoresSucursal({
        id_usuario:userService.getUser().id_usuario,
        id_cliente:userService.getUser().id_cliente,
        id_empresa: this.filtro.id_empresa,
        estado:estado,
        id_sucursal:this.sucursal.id_sucursal
      }).then(data => {
        if (data.status == "success"){
          this.cargarDatos(false);
        }else{
          utils.alerta(data);
        }
      });
    },
  }
}
</script>

<style scoped>
</style>
